exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nh1[data-v-bdd8ccfe] {\n    font-size: 34px;\n    color: red;\n    margin-bottom: 2rem;\n}\n", "", {"version":3,"sources":["/Users/marco/vitamin2/solarapp-frontend-management/src/components/pages/404/src/components/pages/404/NotFound.vue"],"names":[],"mappings":";AAkBA;IACA,gBAAA;IACA,WAAA;IACA,oBAAA;CACA","file":"NotFound.vue","sourcesContent":["<template>\n    <el-row type=\"flex\" justify=\"center\">\n        <el-col :span=\"6\">\n            <div style=\"text-align: center\">\n                <h1>404</h1>\n                <p>Not Found</p>\n            </div>\n        </el-col>\n    </el-row>\n</template>\n\n<script>\n    export default {\n        name: 'NotFound',\n    };\n</script>\n\n<style scoped>\n    h1 {\n        font-size: 34px;\n        color: red;\n        margin-bottom: 2rem;\n    }\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bdd8ccfe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/404/NotFound.vue
// module id = g58T
// module chunks = 1